module.exports = __webpack_public_path__ + "img/Fixed-amount.8b25ba18.svg";